import { ContextWrapper } from "@common/contexts";
import { IntakeStore } from "@customer/stores";

export const IntakeStoreContextWrapper = new ContextWrapper<IntakeStore>();
